<div class="overlay" style="z-index: 5000;" *ngIf="showPanel">
    <kendo-popup class="side-panel-container" [anchor]="anchor" [animate]="animate" [anchorAlign]="anchorAlign" [popupAlign]="popupAlign" *ngIf="showPanel" style="z-index: 5001;">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </kendo-popup>
</div>